import React from "react";
import { default as Clockin } from "components/Dashboard/Dashboard_Clockin"

const Card_Clockin = (props) => {
	return (
		<Clockin />
	);
};

export default Card_Clockin;